import React from "react";
import { Myinfo } from "../Top-division-components/Top-division-components.jsx";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import "./about.css";
import { Logo, LogoSectionAbout } from "../logo-section/logoSection.jsx";
import { FirstPrize, PrizeHeading } from "../prize tracks/prizes.jsx";
import { PrizeInfo, SOCIALS } from "../../Module/General";
import { Accordion } from "../FAQ/faq.jsx";
import { Sponsor, SponsorsHead } from "../Sponsors/sponsors.jsx";
import Birds from "../Birds/birds.jsx";
import Footer from "../Footer/footer.jsx";
import { Member , FacultyMember } from "../team/team.jsx";

import pattern from "./pattern4.png";
import Media from "../media/media.jsx";

import TimeLine from "../Timeline/Timeline.jsx";
import JP_Pandey from "../../Module/Assets/teami/JP_Pandey.jpg"
import Aman from "../../Module/Assets/teami/Aman.JPG"
import Bobis from "../../Module/Assets/sponsorsLogos/bobis.png"
import PowerGrid from "../../Module/Assets/sponsorsLogos/power.png"
import hurl from "../../Module/Assets/sponsorsLogos/hurl.png"
import igl from "../../Module/Assets/sponsorsLogos/igl.png"
import upsec from "../../Module/Assets/sponsorsLogos/upsec.png"
import becceptor from "../../Module/Assets/sponsorsLogos/becceptor.png"

import {
  TOP_SECTION,
  TeamInfo,
  JudgesInfo,
  sponsorLogos,
  frequentlyAskedQuestions,
  designlogo,
  titlesponsorLogos,
  bronzeponsorLogos,
  silversponsorLogos,
  goldsponsorLogos,
  FoodLogos
} from "../../Module/General";
import ThemeType from "components/Themes/theme.jsx";

// javascript Map for sponsors

function SponsorGroup(props) {
  return (
    <Row justifyContent="center" alignItems="center">
      {props.map((s, key) => (
        <Col
          key={key}
          justifyContent="center"
          alignItems="center"
          sm={12}
          lg={4}
          md={6}
        >
          {" "}
          <Sponsor link={s.link} srcx={s.src} />{" "}
        </Col>
      ))}
    </Row>
  );
}

// javascript Map for sponsors end

// Prize group

function PrizeGroup(props) {
  return (
    <Row>
      {props.map((s, key) => (
        <Col key={key} className="" sm={12} lg={4} md={6}>
          <FirstPrize icon={s.icon} type={s.type} content={s.content} />
        </Col>
      ))}
    </Row>
  );
}

// Prize group ending
function TeamMembers(props) {
  return (
    <Row className="members">
      {props.map((s, k) => (
        <Col key={k} className="" sm={12} lg={4} md={4}>
          <Member info={s} />
        </Col>
      ))}
    </Row>
  );
}
function facultyMembers(props) {
  return (
    <Row className="members">
      {props.map((s, k) => (
        <Col key={k} className="" sm={12} lg={4} md={4}>
          <FacultyMember info={s} />
        </Col>
      ))}
    </Row>
  );
}

function FrequentlyAsked(props) {
  return (
    <Row className="sf">
      {props.map((s, k) => (
        <Col key={k} className="" sm={12} lg={6} md={6}>
          <Accordion panels={s} />
        </Col>
      ))}
    </Row>
  );
}

export default function HomePage(props) {

  window.onscroll = () => {
    toggleTopButton();
    console.log(document.body.scrollHeight);
    console.log(document.body.scrollTop);
    console.log("Diff", document.body.scrollHeight - document.body.scrollTop);
  }

  const scrollToTop = (event) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function toggleTopButton() {
    if ((document.body.scrollHeight - document.body.scrollTop) < 800) {
      document.getElementById('back-to-up').style.display = 'none';
    }
    else if (document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20) {
      document.getElementById('back-to-up').style.display = 'block';
    } else {
      document.getElementById('back-to-up').style.display = 'none';
    }
  }



  React.useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://apply";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div id="top" className="Whole_div" style={{ backgroundImage: `url(${pattern})` }}>
      <div className="color_sectiom">
        <Container fluid>
          <Row className="Row info">
            <Col className="info-div" sm={12} lg={7} md={8}>
              <Myinfo />
            </Col>
            <Col className="d-image" sm={12} lg={5} md={4}>
              <img alt="img" src={TOP_SECTION.IMG_SRC} />
              <br />
            </Col>
          </Row>


         
        </Container>
      </div>
      <Container fluid>
        {/* Logo section  */}
        <Row className=" logoSection" id="about">
          <Col className="info-div" sm={12} lg={8} md={8}>
            <LogoSectionAbout />
          </Col>
          <Col className="info-div" sm={12} lg={4} md={4}>
            <Logo />
          </Col>
        </Row>

         {/*Theme Section*/}
         <Row className="prizesection non-coding" id="themes">
          <PrizeHeading type="Hackathon Themes" />
          <ThemeType />
        </Row>

      
         {/*TimeLine Section*/}
         <Row className="timeline" id="timeline">
        <PrizeHeading type="Hackathon TimeLine" />
          <TimeLine />
        </Row>
   

        <Row className="prizesection" id="prizes">
          <PrizeHeading type="Prizes" />
        </Row>
        <div class="row1-container">

          <div class="box red">
            <h2>Overall First</h2><img class="imgright" src="https://img.icons8.com/emoji/96/000000/1st-place-medal-emoji.png" alt="" />
            <h4><b>Prize</b>: Rs. 21,000 <br />Swags & Goodies<br /><br /></h4>
          </div>

          <div class="box box-down cyan">
            <h2>Overall Second</h2><img className="imgright" src="https://img.icons8.com/emoji/96/000000/2nd-place-medal-emoji.png" alt="" />
            <h4><b>Prize</b>: Rs. 10,000 <br />Swags & Goodies<br /><br /></h4>
          </div>

          <div class="box box-down blue">
            <h2>Overall Third</h2><img class="imgright" src="https://img.icons8.com/emoji/96/000000/3rd-place-medal-emoji.png" alt="" />
            <h4><b>Prize</b>: Rs. 6,500 <br />Swags & Goodies<br /><br /></h4>
          </div>
        </div>
        {/*      <div class="row2-container">
        <div class="box orange">
          <h2>Karma</h2>
          <p>Regularly evaluates our talent to ensure quality</p>
          <img class="imgright" src="https://assets.codepen.io/2301174/icon-karma.svg" alt="" />
        </div>
      </div>*/}
        <div class="row1-container margfromsponsor">
          <div class="box box-down orange">
            <h2> Problem Statement Winners</h2><img class="imgright" src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/000000/external-prizes-circus-flaticons-lineal-color-flat-icons.png" alt="" />
            <h4><b>Swags</b><br /><br /><br /></h4>
          </div>
        </div>

         


        
        {/*Theme end*/}

        <Birds top="100vh" left="0vh" type="" />

      


        {/* ********Sponsors here ***** */}

        <Row className="sponsorSection" id="sponsors">
          <SponsorsHead />
         
          <h1 className="">Title Sponsors</h1> 
         <br />
          {/* {titlesponsorLogos.map(SponsorGroup)} */}
          <Row justifyContent="center" alignItems="center">
        <Col
          key="title"
          justifyContent="center"
          alignItems="center"
          sm={12}
          lg={4}
          md={6}
        >
          </Col>
          <div className="Sponsortitle">
    {/*<h3>coming Soon</h3>*/}
     <a href="https://www.instagram.com/bobissince1963/" rel="noreferrer" target="_blank"> <img src={Bobis} alt="BOBIS"></img></a>
    </div>
        
    </Row>
          <h1 className="">Presented By</h1> 
         <br />
          {/* {titlesponsorLogos.map(SponsorGroup)} */}
          <Row justifyContent="center" alignItems="center">
        <Col
          key="title"
          justifyContent="center"
          alignItems="center"
          sm={12}
          lg={4}
          md={6}
        >
          </Col>
          <div className="Sponsortitle">
    {/*<h3>coming Soon</h3>*/}
     <a href="https://www.instagram.com/bobissince1963/" rel="noreferrer" target="_blank"> <img src={PowerGrid} alt="pOWERGRID"></img></a>
    </div>
        
    </Row>
          <h1 className="">Partnered By</h1> 
         <br />
          {/* {titlesponsorLogos.map(SponsorGroup)} */}
          <Row justifyContent="center" alignItems="center">
        <Col
          key="title"
          justifyContent="center"
          alignItems="center"
          sm={12}
          lg={4}
          md={6}
        >
          </Col>
          <div className="Sponsortitle">
    {/*<h3>coming Soon</h3>*/}
     <a href="https://www.instagram.com/bobissince1963/" rel="noreferrer" target="_blank"> <img src={hurl} alt="HURL"></img></a>
    </div>
        
    </Row>
           <h1 className="">Associate Partners</h1> 
         {/* <br /> */}
          {/* {titlesponsorLogos.map(SponsorGroup)} */}
          <Row justifyContent="center" alignItems="center">
        <Col
          key="title"
          justifyContent="center"
          alignItems="center"
          sm={12}
          lg={4}
          md={6}
        >
          </Col>
          <div className="Sponsortitle">
    {/* <h3>coming Soon</h3> */}
     <a href="https://www.instagram.com/bobissince1963/" rel="noreferrer" target="_blank"> <img src={igl} alt="IGL"></img></a>
    </div> 
        
    </Row>
           <h1 className="">Technical Partners</h1> 
         {/* <br /> */}
          {/* {titlesponsorLogos.map(SponsorGroup)} */}
          <Row justifyContent="center" alignItems="center">
        <Col
          key="title"
          justifyContent="center"
          alignItems="center"
          sm={12}
          lg={4}
          md={6}
        >
          </Col>
          <div className="Sponsortitle">
    {/* <h3>coming Soon</h3> */}
     <a href="https://www.instagram.com/bobissince1963/" rel="noreferrer" target="_blank"> <img src={upsec} alt="IEEEUPSEC"></img></a>
    </div> 
        
    </Row>
           <h1 className="">API Sponsors</h1> 
         {/* <br /> */}
          {/* {titlesponsorLogos.map(SponsorGroup)} */}
          <Row justifyContent="center" alignItems="center">
        <Col
          key="title"
          justifyContent="center"
          alignItems="center"
          sm={12}
          lg={4}
          md={6}
        >
          </Col>
          <div className="Sponsortitle">
    {/* <h3>coming Soon</h3> */}
     <a href="https://beeceptor.com/" rel="noreferrer" target="_blank"> <img src={becceptor} alt="Becceptor"></img></a>
    </div> 
        
    </Row>
          {/* <br /><br />
          <h1 className="">Associate Partners</h1>
          <br />
          {goldsponsorLogos.map(SponsorGroup)} */}
          {/* <br /><br /> */}
          {/* <h1 className="">Silver Sponsors</h1> */}
          {/* <br /> */}
          {silversponsorLogos.map(SponsorGroup)}
          {/* <br /><br /> */}
          {/* <h1 className="">Bronze Sponsors</h1> */}
          {/* <br /> */}
          {bronzeponsorLogos.map(SponsorGroup)}
          {/* <br /><br /> */}
          {/* <SponsorUS /> */}<br /><br />
          {/* <h1 className="">Design & Media Partners</h1> */}
          {/* <br /> */}
          {/* {designlogo.map(SponsorGroup)} */}
          {/* <br /><br /> */}
          {/* <h1 className="">API Sponsors</h1>
          <br />
          {FoodLogos.map(SponsorGroup)} */}
          <button> <a target="_blank"href={SOCIALS.email} rel="noreferrer" style={{color:"white"}} ><i class="iconlink fa-solid fa-envelope" style={{color:"white", marginRight:5}}></i>Be Our Sponsor</a></button>
        </Row>
        {/* ********Sponsors ending here ***** */}


        {/* ********Team here ***** */}
        {/* <h1 id="team">Mentor</h1>


        {JudgesInfo.map(TeamMembers)} */}
        <h1 id="teams">Patron</h1>
        <div className="member">
        <img id='teams' className="vc" src={JP_Pandey}  alt="Honourable Vice Chancellor"/>
        
        <h3>Prof. J.P Pandey</h3>
        <p>Honourable Vice Chancellor</p>
      </div>
        <h1 id="teams">Organising Committee</h1>
        {/* {FOOTER.JOIN_TEAM.required && (
          <JoinTeam
            placeholder="Join our team"
            formLink={FOOTER.JOIN_TEAM}
            content="Interested in joining our team"
          />
        )} */}

        {TeamInfo.map(facultyMembers)}
        {/* ********Team ending here ***** */}

        {/* ********Team ending here ***** */}
        <br />

          {/* ********Team here ***** */}
        {/* <h1 id="team">Mentor</h1>


        {JudgesInfo.map(TeamMembers)} */}

        <h1 id="teams">Our Team</h1>
        {/* {FOOTER.JOIN_TEAM.required && (
          <JoinTeam
            placeholder="Join our team"
            formLink={FOOTER.JOIN_TEAM}
            content="Interested in joining our team"
          />
        )} */}
        {JudgesInfo.map(TeamMembers)}
        {/* ********Team ending here ***** */}

        {/* ********Team ending here ***** */}
        <br />
        {/* <h1 id="teams">Our Developer</h1>
        <div className="member">
        <img id='teams' className="vc" src={Aman}  alt="WebGhost"/>
        
        <h3>Aman Poddar</h3>
        <p>Executive Member</p>
        <a href="gserf" rel="noreferrer" target="_blank">
          <i class="fab fa-2x fa-github" style={{marginRight: 10}}></i>
        </a>
        <a href="dsedf" rel="noreferrer" target="_blank">
          <i class="fab fa-2x fa-linkedin"></i>
        </a>
      </div> */}


        <h1 id="faqs">FAQs</h1>
        {/* ********Frequently asked Questions here ***** */}
        <div className="Myfaqs">
          {frequentlyAskedQuestions.map(FrequentlyAsked)}
          {/* ********Frequently asked Questions ending here ***** */}
        </div>
      </Container>
      <br />
     

      <Footer />
      <div class="backtotop" id="back-to-up"><a onClick={scrollToTop}><p><i class="fa-solid fa-arrow-up"></i></p></a></div>
    </div >
  );



}
